import { getAllClasses, getClassFilters, getClassSort } from "../../api"
import { ClassCard } from "../cards/ClassCard"
import ListData from "../common/ListData"

export const UpcomingClasses = () => {
  return (
    <>
      <ListData
        getFilters={getClassFilters}
        getSort={getClassSort}
        getAllData={getAllClasses}
        initialFilters={{
          filter: {
            fromDate: new Date(),
            toDate: null,
          },
        }}
        Card={ClassCard}
        emptyText="No upcoming classes"
      />
      <ClassCard />
      <ClassCard />
    </>
  )
}
